import { formatDate } from "./formatters";

import payment from "payment";

export const phoneFormatter = (value?: string): string | undefined => {
  if (!value) return value;
  const onlyNumbers: string = value.replace(/[^\d]/g, "");
  if (onlyNumbers.length <= 3) return onlyNumbers;
  if (onlyNumbers.length <= 7)
    return `(${onlyNumbers.slice(0, 3)}) ${onlyNumbers.slice(3, 7)}`;
  return `(${onlyNumbers.slice(0, 3)}) ${onlyNumbers.slice(
    3,
    6
  )}-${onlyNumbers.slice(6, 10)}`;
};

export const dateFormatter = (date?: string): string | undefined =>
  formatDate(date, "YYYY-MM-DD");

export const ccFormatter = (cc?: string): string =>
  cc ? payment.fns.formatCardNumber(cc) : "";
